module.exports = __webpack_public_path__ + "static/media/IconReportResult.566d6400.svg";